import React, { useState } from "react";
import styles from "./ChangeStatusModal.module.css";
import PropTypes from "prop-types";

import { Modal } from "@wwg/ui";
import { Select } from "shared/Select/Select";

/**
 * Interactive component.
 * Changes the status of an account on the IBO file page.
 */
export function ChangeStatusModal({ isOpen, onSend, onClose }) {
  const [account, setAccount] = useState("");
  const [status, setStatus] = useState("");

  return (
    <Modal
      visible={isOpen}
      onClick={onClose}
      children={
        <div className={styles.container}>
          <div className={styles.title}>Change Status</div>
          <div className={styles.hr} />

          <div className={styles.title}>Select Account:</div>
          <div className={styles.select}>
            <Select
              options={[
                "DreamStream",
                "CommuniKate",
                "Events",
                "Membership/Digital Delivery",
              ]}
              placeholder={account ? account : "Select"}
              onChange={setAccount}
            />
          </div>

          <div className={styles.title}>Change Status To:</div>
          <div className={styles.select}>
            <Select
              options={["Active", "Suspended", "Inactive"]}
              placeholder={status ? status : "Select"}
              onChange={setStatus}
            />
          </div>

          <div className={styles.buttonContainer}>
            <button
              type="button"
              className={styles.button}
              onClick={() => {
                onSend(account, status.toLowerCase());
                onClose();
              }}
            >
              Submit
            </button>
          </div>
        </div>
      }
    />
  );
}

ChangeStatusModal.propTypes = {
  /**
   * Function called when the "send for approval" button is clicked.
   */
  onSend: PropTypes.func,
  /**
   * Determines if modal is displayed.
   */
  isOpen: PropTypes.bool,
  /**
   * Function that fires when the modal is closed.
   */
  onClose: PropTypes.func,
};
